import React, { useState, useContext, useEffect } from "react";
import { styled } from '@mui/material/styles';
// import { Storage } from "aws-amplify";
import { useMediaQuery } from "react-responsive";

import { SeisoenContext } from "../../context/seisoen-context";
import { BoerderyContext } from "../../context/boerdery-context";
import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import logo from "../../assets/images/logo_wit_1280x500.png";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Loader from '../../components/Loader/Loader';
import { withTranslation } from "react-i18next";

const PREFIX = 'Topbar';

const classes = {
  root: `${PREFIX}-root`,
  flexGrow: `${PREFIX}-flexGrow`,
  seisoendropdownicon: `${PREFIX}-seisoendropdownicon`,
  arrow: `${PREFIX}-arrow`,
  spaceRight: `${PREFIX}-spaceRight`
};

const StyledAppBar = styled(AppBar)((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    boxShadow: "none",
  },

  [`& .${classes.flexGrow}`]: {
    flexGrow: 1,
  },

  [`& .${classes.seisoendropdownicon}`]: {
    marginLeft: "5px",
  },

  [`& .${classes.arrow}`]: {
    margin: "0 10px",
  },

  [`& .${classes.spaceRight}`]: {
    marginRight: "10px",
  }
}));

const Topbar = ({ t, ...props }) => {
  const seisoenContext = useContext(SeisoenContext);
  const boerderyContext = useContext(BoerderyContext);

  const { onSidebarOpen } = props;


  const [seisoene, setSeisoene] = useState([]);
  const [seisoen, setSeisoen] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [gekiesdeSeisoen, setGekiesdeSeisoen] = useState("");
  const [anchorElBoerdery, setAnchorElBoerdery] = useState(null);
  const [openDialogBoerdery, setOpenDialogBoerdery] = useState(false);
  const [boerderye, setBoerderye] = useState([]);
  const openBoerdery = Boolean(anchorElBoerdery);
  const [aktieweboerdery, setAktieweboerdery] = useState({});
  const [gekiesdeBoerdery, setGekiesdeBoerdery] = useState("");
  const [loadingBoerderye, setLoadingBoerderye] = useState(true);
  const [loadingSeisoene, setLoadingSeisoene] = useState(true);
  const [logoSource,] = useState(logo);

  const [kliente, setKliente] = useState([]);
  const [anchorElKlient, setAnchorElKlient] = useState(null);
  const [openDialogKlient, setOpenDialogKlient] = useState(false);
  const openKlient = Boolean(anchorElKlient);
  const [aktieweklient, setAktieweklient] = useState({});
  const [gekiesdeKlient, setGekiesdeKlient] = useState("");
  const [loadingKliente, setLoadingKliente] = useState(true);

  useEffect(() => {
    if (boerderyContext.boerdery) {
      setAktieweboerdery(boerderyContext.boerdery);
      return () => { };
    } else {
      setAktieweboerdery({});
    }
  }, [boerderyContext.boerdery]);

  useEffect(() => {
    if (boerderyContext.klient) {
      setAktieweklient(boerderyContext.klient);
      return () => { };
    } else {
      setAktieweklient({});
    }
  }, [boerderyContext.klient]);

  useEffect(() => {
    if (boerderyContext.boerderye && boerderyContext.boerderye.length > 0) {
      setBoerderye(boerderyContext.boerderye);
      setLoadingBoerderye(false);
      return () => { };
    } else {
      setBoerderye([]);
    }
  }, [boerderyContext.boerderye]);

  useEffect(() => {
    if (boerderyContext.kliente && boerderyContext.kliente.length > 0) {
      setKliente(boerderyContext.kliente);
      setLoadingKliente(false);
      return () => { };
    } else {
      setKliente([]);
    }
  }, [boerderyContext.kliente]);

  useEffect(() => {
    if (seisoenContext.seisoene) {
      setSeisoene(seisoenContext.seisoene);
      setLoadingSeisoene(false);
      return () => { };
    } else {
      setSeisoene([]);
    }
  }, [seisoenContext.seisoene]);

  useEffect(() => {
    if (seisoenContext.seisoen) {
      setSeisoen(seisoenContext.seisoen);
      setLoadingSeisoene(false);
      return () => { };
    } else {
      setSeisoen({});
    }
  }, [seisoenContext.seisoen]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const kiesSeisoen = (event, option) => {
    setGekiesdeSeisoen(option);
    setOpenDialog(true);
    handleClose();
  };

  const kiesSeisoenFinaal = () => {
    seisoenContext.stelseisoen(gekiesdeSeisoen);
    setSeisoen(gekiesdeSeisoen);
    handleDialogClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    handleClose();
  };

  const handleOpenBoerdery = (event) => {
    setAnchorElBoerdery(event.currentTarget);
  };

  const handleCloseBoerdery = () => {
    setAnchorElBoerdery(null);
  };

  const handleDialogCloseBoerdery = () => {
    setOpenDialogBoerdery(false);
    handleCloseBoerdery();
  };

  const kiesBoerdery = (event, option) => {
    setGekiesdeBoerdery(option);
    setOpenDialogBoerdery(true);
    handleCloseBoerdery();
  };

  const kiesBoerderyFinaal = () => {
    boerderyContext.stelboerdery(gekiesdeBoerdery);
    setAktieweboerdery(gekiesdeBoerdery);
    handleDialogCloseBoerdery();
    seisoenContext.stelseisoen("");
    seisoenContext.stelseisoene([]);
    setSeisoen("");
    setSeisoen([]);
    seisoenContext.stelreload(seisoenContext.reload + 1);
    boerderyContext.stelklient({});
    boerderyContext.stelkliente([]);
  };

  const handleOpenKlient = (event) => {
    setAnchorElKlient(event.currentTarget);
  };

  const handleCloseKlient = () => {
    setAnchorElKlient(null);
  };

  const handleDialogCloseKlient = () => {
    setOpenDialogKlient(false);
    handleCloseKlient();
  };

  const kiesKlient = (event, option) => {
    setGekiesdeKlient(option);
    setOpenDialogKlient(true);
    handleCloseKlient();
  };

  const kiesKlientFinaal = () => {
    boerderyContext.stelklient(gekiesdeKlient);
    setAktieweklient(gekiesdeKlient);
    handleDialogCloseKlient();
    seisoenContext.stelseisoen("");
    seisoenContext.stelseisoene([]);
    setSeisoen("");
    setSeisoen([]);
    seisoenContext.stelreload(seisoenContext.reload + 1);
  };

  const isDesktop = useMediaQuery({ minWidth: 1200 });

  const boerderyDialog = (
    <Dialog open={openDialogBoerdery} onClose={handleDialogCloseBoerdery}>
      <DialogTitle>{t("Is jy seker jy wil van boerdery verander?")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("As jy van boedery verander sal jou blokke, plukstate, ens. laai van hierdie boerdery.")}
        </DialogContentText>
        <h1>
          {aktieweboerdery.boerderynaam}
          <ArrowForwardIcon className={classes.arrow} />
          {gekiesdeBoerdery.boerderynaam}
        </h1>
      </DialogContent>
      <DialogActions>
        <Button
          variant="cancel"
          onClick={handleDialogCloseBoerdery}
        >
          {t("Nee")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={kiesBoerderyFinaal}
          autoFocus
        >
          {t("Ja")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  const klientDialog = (
    <Dialog open={openDialogKlient} onClose={handleDialogCloseKlient}>
      <DialogTitle>
        {t("Is jy seker jy wil van boerdery klient verander?")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("As jy van boedery klient verander sal jou blokke, plukstate, ens. laai van hierdie boerdery.")}
        </DialogContentText>
        <h1>
          {aktieweklient.boerderynaam}
          <ArrowForwardIcon className={classes.arrow} />
          {gekiesdeKlient.boerderynaam}
        </h1>
      </DialogContent>
      <DialogActions>
        <Button
          variant="cancel"
          onClick={handleDialogCloseKlient}
        >
          {t("Nee")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={kiesKlientFinaal}
          autoFocus
        >
          {t("Ja")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  const dialog = (
    <Dialog open={openDialog} onClose={handleDialogClose}>
      <DialogTitle>{t("Is jy seker jy wil van seisoen verander?")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("As jy van seisoen verander sal jou blokke, plukstate, ens. laai van hierdie seisoen.")}
        </DialogContentText>
        <h1>
          {seisoen.naam}
          <ArrowForwardIcon className={classes.arrow} />
          {gekiesdeSeisoen.naam}
        </h1>
      </DialogContent>
      <DialogActions>
        <Button
          variant="cancel"
          onClick={handleDialogClose}
        >
          {t("Nee")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={kiesSeisoenFinaal}
          autoFocus
        >
          {t("Ja")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <StyledAppBar className="appBar">
      <Toolbar>
        {!isDesktop ? (
          <IconButton color="inherit" onClick={onSidebarOpen} size="large">
            <MenuIcon />
          </IconButton>
        ) : (
          <img alt={t("Boerdery bestuur")} src={logoSource} className="pageLogo" />
        )}
        <div className={classes.flexGrow} />
        {loadingBoerderye || aktieweboerdery.boerderyuuid ? (
          <React.Fragment>
            <div className={classes.spaceRight}>
              <Tooltip title={t("Jy kyk na data van bogenoemde boerdery")} arrow>
                <Button
                  className="mainboerderybutton"
                  onClick={handleOpenBoerdery}
                  disabled={boerderyContext.disabled}
                >
                  {aktieweboerdery.boerderynaam}
                  <KeyboardArrowDownIcon
                    className={classes.seisoendropdownicon}
                  />
                </Button>
              </Tooltip>
              <Menu
                id="boerdery-menu"
                anchorEl={anchorElBoerdery}
                keepMounted
                open={openBoerdery}
                onClose={handleDialogCloseBoerdery}
                PaperProps={{ style: { maxHeight: 300 } }}
              >
                {loadingBoerderye ? (
                  <Loader type="Oval" />
                ) : (
                  boerderye.map((boerdery) =>
                    boerdery.boerderyuuid ? (
                      <MenuItem
                        key={boerdery.boerderyuuid}
                        selected={
                          boerdery.boerderynaam === aktieweboerdery.boerderynaam
                        }
                        onClick={(event) => kiesBoerdery(event, boerdery)}
                      >
                        {boerdery.boerderynaam}
                      </MenuItem>
                    ) : null
                  )
                )}
              </Menu>
              {boerderyDialog}
            </div>
            {loadingKliente ||
              kliente.length < 1 ? null : aktieweboerdery.boerderyuuid !==
                aktieweklient.boerderyuuid ||
                (aktieweboerdery.boerderyuuid === aktieweklient.boerderyuuid &&
                  kliente.length > 1) ? (
              <div className={classes.spaceRight}>
                <Tooltip
                  title={t("Jy kyk na data van bogenoemde boerdery klient")}
                  arrow
                >
                  <Button
                    className="boerderybutton"
                    onClick={handleOpenKlient}
                    disabled={boerderyContext.disabled}
                  >
                    {aktieweklient.boerderynaam}
                    <KeyboardArrowDownIcon
                      className={classes.seisoendropdownicon}
                    />
                  </Button>
                </Tooltip>
                <Menu
                  id="klient-menu"
                  anchorEl={anchorElKlient}
                  keepMounted
                  open={openKlient}
                  onClose={handleDialogCloseKlient}
                  PaperProps={{ style: { maxHeight: 300 } }}
                >
                  {loadingKliente ? (
                    <Loader type="Oval" />
                  ) : (
                    kliente.map((klient) =>
                      klient.boerderyuuid ? (
                        <MenuItem
                          key={klient.boerderyuuid}
                          selected={
                            klient.boerderynaam === aktieweklient.boerderynaam
                          }
                          onClick={(event) => kiesKlient(event, klient)}
                        >
                          {klient.boerderynaam}
                        </MenuItem>
                      ) : null
                    )
                  )}
                </Menu>
                {klientDialog}
              </div>
            ) : null}
            <div>
              <Tooltip title={t("Jy kyk na data van bogenoemde seisoen")} arrow>
                <Button
                  className="seisoenbutton"
                  onClick={handleOpen}
                  disabled={seisoenContext.disabled}
                >
                  {seisoen.naam}
                  <KeyboardArrowDownIcon
                    className={classes.seisoendropdownicon}
                  />
                </Button>
              </Tooltip>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{ style: { maxHeight: 300 } }}
              >
                {loadingSeisoene ? (
                  <Loader type="Oval" />
                ) : (
                  seisoene.map((rekord) =>
                    rekord.id ? (
                      <MenuItem
                        key={rekord.id}
                        selected={rekord.naam === seisoen.naam}
                        onClick={(event) => kiesSeisoen(event, rekord)}
                      >
                        {rekord.naam}
                      </MenuItem>
                    ) : null
                  )
                )}
              </Menu>
              {dialog}
            </div>
          </React.Fragment>
        ) : null}
      </Toolbar>
    </StyledAppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
};

export default withTranslation(["translation"])(Topbar);
